import { defineFormConfig } from "@src/components/business-form";
import type { StockActInvFactQtyByStorePlaceData } from "../../../../../../api/stockActInvs";

/** Значение фактического количества по ячейке в форме инвентаризации. */
export interface StockFullInventoryFactQtyByStorePlaceFormValues {
    /** Код ячейки места хранения. */
    spCode: number;
    /** Текст ячейки для динамического label поля. */
    cellText: string;
    /** Фактическое количество в ячейке. */
    factQty: number;
}

/** Значения формы инвентаризации строки АИ. */
export interface StockFullInventoryContentFormValues {
    /** Суммарное фактическое количество по строке. */
    factQty: number;
    /** Фактические количества по местам хранения. */
    factQtyByStorePlaces: StockFullInventoryFactQtyByStorePlaceFormValues[];
}

/** Доменная часть формы инвентаризации без кода строки АИ. */
export interface StockFullInventoryContentFormDomain {
    /** Суммарное фактическое количество по строке. */
    factQty: number;
    /** Фактические количества по местам хранения, если партия хранится в ячейках. */
    factQtyByStorePlaces?: StockActInvFactQtyByStorePlaceData[];
}

/** Конфигурация формы инвентаризации строки АИ. */
export const stockFullInventoryContentFormConfig = defineFormConfig<
    StockFullInventoryContentFormValues,
    StockFullInventoryContentFormDomain
>({
    fields: {
        factQty: {
            type: "number",
            label: "Фактическое количество",
            default: 0,
            validation: { required: true, min: 0 },
            map: "factQty",
        },
        factQtyByStorePlaces: {
            type: "array",
            label: "Фактический остаток по местам хранения",
            default: [],
            map: "factQtyByStorePlaces",
            itemFields: {
                factQty: {
                    type: "number",
                    label: (item) => `Кол-во факт в ячейке ${item.cellText}`,
                    validation: { required: true, min: 0 },
                    map: "factQty",
                },
            },
        },
    },
    toDomainOverride: (values) => {
        if (values.factQtyByStorePlaces.length === 0) {
            return {
                factQty: values.factQty,
            };
        }

        const factQtyByStorePlaces = values.factQtyByStorePlaces.map((item) => ({
            spCode: item.spCode,
            factQty: item.factQty,
        }));

        return {
            factQty: factQtyByStorePlaces.reduce((sum, item) => sum + item.factQty, 0),
            factQtyByStorePlaces,
        };
    },
});
